export default {
    NotLoaded: 'NotLoaded',
    Loading: 'Loading',
    NotSignedIn: 'NotSignedIn',
    SwitchUser: 'SwitchUser',
    SigningIn: 'SigningIn',
    SignedIn: 'SignedIn',
    SignedOut: 'SignedOut'
};